import { IRoundDataModel } from '../../data-models/round.data-model';
import { IInitializedFormatter } from './IInitializedFormatter';

export class RoundFormatter
  implements IInitializedFormatter<Map<number, IRoundDataModel>, number | number[]>
{
  #rounds: Map<number, IRoundDataModel> = new Map();

  init(rounds: Map<number, IRoundDataModel>) {
    this.#rounds = rounds;
    return this;
  }

  format = (value: number | number[] | null | undefined) => {
    if (Array.isArray(value)) {
      return value.map(this.#format).join(', ');
    }
    return this.#format(value);
  };

  #format = (value: number | null | undefined) => {
    if (value == null) {
      return '';
    }
    return this.#rounds.get(value)?.displayName ?? `Unknown round: ${value}`;
  };
}
